<template>
    <div class="form-field form-field--tree form-field--tree-not-nowrap">
        <label :for="id"
            >{{ label }} <span v-if="required" class="required">*</span></label
        >
        <treeselect
            v-model="value"
            :multiple="false"
            :options="options"
            valueFormat="object"
            :clearOnSelect="true"
        />
        <div class="form-field--other" v-if="custom">
            <div class="checkbox">
                <div class="form-field checkbox-wrap">
                    <input
                        type="checkbox"
                        :id="`${id}_is_other_value`"
                        :name="`${name}_is_other_value`"
                        @change="is_other = !is_other"
                    />
                    <label :for="`${id}_is_other_value`">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Other
                </div>
            </div>
            <div class="control" v-if="is_other">
                <div class="form-field">
                    <input
                        :name="`${name}_other`"
                        placeholder="Other value..."
                        v-model="other_value"
                    />
                </div>
            </div>
        </div>
        <div class="form-field--not-applicable" v-if="not_applicable">
            <div class="checkbox">
                <div class="form-field checkbox-wrap">
                    <input
                        type="checkbox"
                        v-model="is_not_applicable"
                        :id="`${id}_not_applicable`"
                        :name="`${name}_not_applicable`"
                        @change="onChangeIsNotApplicable"
                    />
                    <label :for="`${id}_not_applicable`">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Not applicable
                </div>
            </div>
        </div>
        <span
            class="error"
            :style="!custom ? 'bottom: 4px' : 'bottom: 24px'"
            v-if="error"
            >{{ error }}</span
        >
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "Select",
    data() {
        return {
            value: null,
            is_other: false,
            other_value: "",
            is_not_applicable: false,
        };
    },
    components: {
        Treeselect,
    },
    props: [
        "id",
        "label",
        "name",
        "required",
        "setHasErrors",
        "onChange",
        "defaultValue",
        "options",
        "error",
        "custom",
        "not_applicable",
    ],
    mounted() {
        if (this.defaultValue) {
            this.value = this.defaultValue.value || null;
            this.not_applicable = this.defaultValue.not_applicable || false;
            this.other_value = this.other || "";
        }
    },
    watch: {
        other_value: function (val) {
            this.onChange(this.name, {
                value: this.value,
                other: this.other_value,
            });
        },
        is_other: function (val) {
            this.onChange(this.name, {
                value: this.value,
                other: this.other_value,
            });
        },
        value: function (val) {
            this.onChange(this.name, {
                value: this.value,
                other: this.other_value,
            });
        },
    },

    methods: {
        onChangeIsNotApplicable(e) {
            if (e.target.checked) {
                this.is_not_applicable = true;
                this.onChange(this.name, {
                    value: null,
                    other: "",
                    not_applicable: this.is_not_applicable,
                });

                this.value = null;
                this.other_value = "";
                this.is_other = false;
            } else {
                this.is_not_applicable = false;
            }
        },
    },
};
</script>
